import { useMutation } from '@apollo/client';
import { Toggle } from '@fluentui/react';
import { SupplierExportInput } from 'common/types/globalTypes';
import React, { useState } from 'react';
import { SupplierRowItem } from '..';
import {
  SupplierExport,
  SupplierExportVariables,
} from './__generated__/SupplierExport';
import { ExportToCsv } from 'common/components/ExportToCsv';

import SUPPLIER_LIST_EXPORT from './SupplierExport.graphql';
import { toSelection } from 'common/utils/entity';

interface ExportSuppliersProps {
  selectedRows: SupplierRowItem[];
  isSelectedAllDefault: boolean;
}

export const ExportSuppliers: React.FC<ExportSuppliersProps> = ({
  selectedRows,
  isSelectedAllDefault,
}) => {
  const [isSelectedAll, setSelectedAll] = useState(isSelectedAllDefault);
  const [supplierExport] = useMutation<SupplierExport, SupplierExportVariables>(
    SUPPLIER_LIST_EXPORT
  );

  const additionalComponents = (
    <Toggle
      inlineLabel
      label="All Suppliers"
      checked={isSelectedAll}
      onChange={(_, value) => setSelectedAll(!!value)}
    />
  );

  const getExportCycle = async (description: string | undefined) => {
    const exportVariable: SupplierExportInput = {
      exportDescription: description,
      entitySelection: selectedRows.map(toSelection),
      isAllExported: isSelectedAll,
    };
    const { errors, data } = await supplierExport({
      variables: {
        input: exportVariable,
      },
    });

    return {
      id: data?.supplierExport?.exportResult?.exportCycles?.[0],
      errors,
    };
  };

  return (
    <ExportToCsv
      isButtonVisible={isSelectedAll || selectedRows.length > 0}
      title="Enter the description and press confirm to download the Supplier list."
      additionalComponents={additionalComponents}
      onDialogOpen={() => {
        setSelectedAll(isSelectedAllDefault);
      }}
      getExportCycle={getExportCycle}
    />
  );
};
